import {useState, useEffect} from 'react';
import * as Styled from './HowItWorksStyles';
import {Carousel} from 'react-bootstrap';
import Headline from '../Headline/Headline';
import SlideImage1 from '../../../images/how-it-works-1.png';
import SlideImage2 from '../../../images/how-it-works-2.png';
import SlideImage3 from '../../../images/how-it-works-3.png';
import SlideImage4 from '../../../images/how-it-works-4.png';
import ChevronLeft from '../../../images/chevron-left.png';
import ChevronRight from '../../../images/chevron-right.png';

const HowItWorks = () => {
	const [idx, setIdx] = useState(0);
	const goPrev = () => {
		if (idx === 0) {
			setIdx(3);
			return;
		}
		setIdx(idx - 1);
	}

	const goNext = () => {
		if (idx === 3) {
			setIdx(0);
			return;
		}
		setIdx(idx + 1);
	}
	useEffect(() => {
		const interval = setInterval(() => {
			setIdx(index => {
				if (index === 3) {
					return 0;
				}
				return index + 1;
			});
		}, 5000);
		return () => {
			clearInterval(interval);
		};
	}, []);

	return (
		<Styled.Container id='how-it-works'>
			<Headline tag="h1">How it Works</Headline>
			<Carousel
				controls={false}
				nextIcon={null}
				prevIcon={null}
				indicators={false}
				activeIndex={idx}
			>
				<Carousel.Item>
					<Styled.Slide>
						<Styled.SlideCaption>
							Connect all your accounts and save time by finding the scattered information in just one search.
						</Styled.SlideCaption>
						<Styled.SlideImg src={SlideImage1} />
					</Styled.Slide>
				</Carousel.Item>
				<Carousel.Item>
					<Styled.Slide>
						<Styled.SlideCaption>
							Ask as if you’re talking to your personal assistant.
						</Styled.SlideCaption>
						<Styled.SlideImg src={SlideImage2} />
					</Styled.Slide>
				</Carousel.Item>
				<Carousel.Item>
					<Styled.Slide>
						<Styled.SlideCaption>
							It’s okay that you don’t remember,
							Trova will find it for you.
						</Styled.SlideCaption>
						<Styled.SlideImg src={SlideImage3} />
					</Styled.Slide>
				</Carousel.Item>
				<Carousel.Item>
					<Styled.Slide>
						<Styled.SlideCaption>
							See the full message or conversation Trova instantly takes you to the original message.
						</Styled.SlideCaption>
						<Styled.SlideImg src={SlideImage4} />
					</Styled.Slide>
				</Carousel.Item>
			</Carousel>
			<Styled.Pagination>
				<Styled.PaginateButton onClick={goPrev}>
					<Styled.PaginateImg src={ChevronLeft} />
				</Styled.PaginateButton>
				{`${idx + 1} / 4`}
				<Styled.PaginateButton onClick={goNext}>
					<Styled.PaginateImg src={ChevronRight} />
				</Styled.PaginateButton>
			</Styled.Pagination>
			<Styled.StyledLink to="/security" >
				How We Protect Your Privacy
			</Styled.StyledLink>
		</Styled.Container>
	);
}

export default HowItWorks;